import { NamePrefixModifier, withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { valueOrDefault } from 'Lib/Any';
import { pipe } from 'Lib/Hooks/Selectors';
import { useSelector } from 'react-redux';
import { PageSection } from '../../../Layout';
import {
  WorksheetImagesAndRemarksSection,
  WorksheetResultsSection,
  WorksheetRootComponent,
  WorksheetTestedBySection,
} from '../../Core';
import ids from '../../QestIds';
import { PreparationSection, ResultSection } from './Sections';
import InitialDryingSection from './Sections/InitialDryingSection';
import MeasurementSection from './Sections/MeasurementSection';

const qestIds = [ids.binderContent.AS_2891_3_2.rev2013];

let BinderContentWorksheet: WorksheetRootComponent = ({ createWorksheetSelector }) => {
  const needsInitialDrying = useSelector(
    pipe(createWorksheetSelector!('Preparation.ContainsMoistureOrVolatileOils'), valueOrDefault(false))
  );

  return (
    <>
      <PageSection heading="Test Preparation">
        <NamePrefixModifier appendNamePrefix="Preparation">
          <PreparationSection />
        </NamePrefixModifier>
      </PageSection>
      <PageSection heading="Initial Drying" visible={needsInitialDrying}>
        <NamePrefixModifier appendNamePrefix="InitialDrying">
          <InitialDryingSection />
        </NamePrefixModifier>
      </PageSection>
      <PageSection heading="Measurements">
        <NamePrefixModifier appendNamePrefix="Measurements">
          <MeasurementSection />
        </NamePrefixModifier>
      </PageSection>
      <PageSection>
        <WorksheetTestedBySection />
      </PageSection>
      <WorksheetResultsSection heading="Results">
        <NamePrefixModifier appendNamePrefix="Results">
          <ResultSection />
        </NamePrefixModifier>
      </WorksheetResultsSection>
      <PageSection heading="Images and Remarks">
        <WorksheetImagesAndRemarksSection />
      </PageSection>
    </>
  );
};

BinderContentWorksheet = withInjectedProps(BinderContentWorksheet);
BinderContentWorksheet.qestIds = qestIds;

export default BinderContentWorksheet;
export { BinderContentWorksheet };
